module.exports = {
    // debug: true,
    i18n: {
        defaultLocale: 'us',
        locales: [
            'us',
            'jp',
            'cn',
            'fr',
            'it',
            'ko',
            'nl',
            'ru',
            'de',
            'es',
            'uk',
            'zh_TW',
            'tw',
            'eu',
            'pt_BR',
            'br',
            'pl_PL',
            'pl',
            'cs_CZ',
            'cz',
            'hu_HU',
            'hu',
            'sv_SE',
            'se',
        ],
    },
};
